import StationsMap from '../../Sections/StationsMap/StationsMap.js';
import ScrollMagic from 'scrollmagic';
import 'ScrollMagicAddIndicators';
import $ from 'jquery';

export default {
	init() {

		StationsMap.init();

		function calcTopPosition( url, variable ) {

			var query = url.split('?')[1];

			if( query ) {

				var parameters = query.split('&');
				var sectionName;

				parameters.forEach( function(cell, index) {

					parameters[index] = cell.split('=');

				});

				parameters.forEach( function( cell , index ) {

					if( cell[0] == variable ) {

						sectionName = cell[1];

					}

				});

				var section = document.querySelector('.'+sectionName );

				if( section ) {

					if( section.classList.contains('sectionWithSteps') ) {

						return section.offsetTop + parseFloat( getComputedStyle( section.querySelector('.sectionWithSteps__content') ).getPropertyValue('padding-top').replace('px','') ) - (document.querySelector('header').offsetHeight + 8);

					} else if( sectionName !== 'instrukcjaobslugi' ) {

						return section.offsetTop - document.querySelector('header').offsetHeight;

					} else {

						return section.offsetTop - document.querySelector('header').offsetHeight + (section.querySelector('.sectionTitle').offsetTop * 0.9);

					}

				}

			}

		}

		function StationScroll( topPosition ) {

			$('html ,body').animate({'scrollTop': topPosition }, 'smooth');

		}

		function SubMenuClick( container ) {

			var mainMenuBoxs = document.querySelectorAll('header nav.menu__main .menuBox');
			var mobileMenuBoxs = document.querySelectorAll('.mobileMenu .mobileMenu__menu .menuSublist');

			var mainMenuBoxCurrent = null;
			var mobileMenuBoxCurrent = null;

			var pageUrl = container.getAttribute('data-url');

			// -- Find SubMenu -- //

				mainMenuBoxs.forEach( function( menu, index ) {

					if( menu.querySelector('.menuItem--parent').getAttribute('href') == pageUrl ) {

						mainMenuBoxCurrent = menu;

					}

				});

				mobileMenuBoxs.forEach( function( menu, index ) {

					if( menu.getAttribute('data-parent') == pageUrl ) {

						mobileMenuBoxCurrent = menu;

					}

				});

			// -- END -- //


			// -- MainMenu SubMenu item click -- //

				if( mainMenuBoxCurrent != null ) {

					var mainItems = mainMenuBoxCurrent.querySelectorAll('.menuSublist a');
					var sectionNumberMain;

					mainItems.forEach( function( item, index ) {

						item.addEventListener('click',function(e) {

							e.preventDefault();

							StationScroll( calcTopPosition( item.getAttribute('href'), variable ) );

						});

					});

				}

			// -- END -- //


			// -- MobileMenu SubMenu item click -- //

				if( mobileMenuBoxCurrent!==null ) {

					var mobileItems = mobileMenuBoxCurrent.querySelectorAll('li a');
					var sectionNumberMobile = 1;

					mobileItems.forEach( function( item, index ) {

						item.addEventListener('click', function(e) {

							e.preventDefault();

							StationScroll( calcTopPosition( item.getAttribute('href'), variable ) );

						});

					});

				}

			// -- END -- //

		}

		function StationsScroll( container ) {

			window.scrollTo({
			    top: calcTopPosition( window.location.href, variable ),
			    behavior: 'smooth'
			});

		}

		
		var container = document.querySelector('main.stations');

		
		if( container ) {		

			var variable = container.getAttribute('data-var');

			if( variable ) {

				StationsScroll( container );
				SubMenuClick( container );

			}

		}
    	
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
